import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StateButtonComponent } from './state-button.component';



@NgModule({
  declarations: [
    StateButtonComponent
  ],
	exports: [
		StateButtonComponent,
	],
  imports: [
    CommonModule
  ]
})
export class StateButtonModule { }
